// Polyfills.
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js';
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-listformat/polyfill';
import '@formatjs/intl-listformat/locale-data/en';
import '@formatjs/intl-listformat/locale-data/cy';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/cy';

// React.
import React, { Fragment } from 'react';
import * as serviceWorker from './serviceWorker';
import { ThroughProvider } from 'react-through';
import { createRoot } from 'react-dom/client';

// Routing.
import { BrowserRouter as Router } from 'react-router-dom';

// Internationalisation.
import { I18nextProvider } from 'react-i18next';

// Translations.
import localEn from './translations/en/local';
import localCy from './translations/cy/local';
import initI18next from '@careers-wales/react-components/dist/helpers/initI18next';

// Authentication.
import initMsal from '@careers-wales/react-components/dist/helpers/initMsal';
import AuthenticationProvider from '@careers-wales/react-components/dist/providers/AuthenticationProvider';

// Configuration.
import config from './config';

// Providers.
import LanguageSwitcherProvider from '@careers-wales/react-components/dist/providers/LanguageSwitcherProvider';
import SessionProvider from '@careers-wales/react-components/dist/providers/SessionProvider';
import AppRouterProvider from '@careers-wales/react-components/dist/providers/AppRouterProvider';

// Components.
import BaseApp from '@careers-wales/react-components/dist/components/misc/BaseApp/BaseApp.js';

import App from './App';

// Redirect to the base path on start in development mode only.
if (process.env.NODE_ENV === 'development') {
  if (window.location.pathname === '/') {
    window.location.href = config.basePath.en;
  }
}

// Determine the language code based on the current path.
const langcode = window.location.href.includes(config.basePath.cy) ? 'cy' : 'en';
const switchLangcode = langcode === 'en' ? 'cy' : 'en';

// Set the document <html/> lang attribute to current langcode.
document.documentElement.lang = langcode;

// Configure the authentication.
const msalInstance = initMsal(config, langcode);

// Configure the translations.
const i18nextInstance = initI18next(langcode, [
  { langcode: 'en', json: localEn },
  { langcode: 'cy', json: localCy }
]);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18nextInstance}>
    <ThroughProvider>
      <Fragment>
        <Router basename={config.basePath[langcode]}>
          <AuthenticationProvider instance={msalInstance}>
            <LanguageSwitcherProvider baseUrl={config.baseUrl[switchLangcode] + config.basePath[switchLangcode]}>
              <SessionProvider>

                <AppRouterProvider config={config}>

                  <BaseApp config={config}>

                    <App />
                  </BaseApp>
                </AppRouterProvider>
              </SessionProvider>
            </LanguageSwitcherProvider>
          </AuthenticationProvider>
        </Router>
      </Fragment>
    </ThroughProvider>
  </I18nextProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
